(function ($) {
  Drupal.behaviors.elcSdProductRecommendationsV2 = {
    attach: function (context, settings) {
      var self = this;
      if (self.attached) {
        return;
      }

      self.init(context);
      self.attached = true;
    },

    init: function (context) {
      var self = this;

      $('.js-product-recommendations-v2', context).each(function (_i) {
        self.initWidget($(this));
      });
    },

    initWidget: function ($container) {
      var self = this;
      var placementId = $container.attr('data-placement-id');
      var eventType = $container.attr('data-event-type');
      var resultsNumber = $container.attr('data-results-number');
      var googleFilter = $container.attr('data-filter');
      var useNGGlobal = $container.attr('data-use-ngglobal');
      var dryRun = $container.attr('data-dry-run');
      var productId = $container.attr('data-product-id-tag') || '';
      productId = productId.replace('PROD', '');

      if (site.trackingDataLayer) {
        site.trackingDataLayer.update({
          placement_id: placementId
        });
      }

      self.loadRecommendations(
        placementId,
        eventType,
        resultsNumber,
        googleFilter,
        useNGGlobal,
        dryRun,
        productId,
        $container
      );
    },

    loadRecommendations: function (
      placementId,
      eventType,
      resultsNumber,
      googleFilter,
      useNGGlobal,
      dryRun,
      productId,
      $container
    ) {
      var self = this;
      var params = self.buildDataObject(
        placementId,
        eventType,
        resultsNumber,
        googleFilter,
        useNGGlobal,
        dryRun,
        productId
      );
      self.getRecommendations(params, $container);
    },

    buildDataObject: function (
      placementId,
      eventType,
      resultsNumber,
      googleFilter,
      useNGGlobal,
      dryRun,
      productId
    ) {
      return {
        useNGGlobal: useNGGlobal,
        dryRun: dryRun,
        eventType: eventType,
        placementId: placementId,
        pageSize: resultsNumber,
        filter: googleFilter,
        productId: productId
      };
    },

    getRecommendations: function (params, $container) {
      var self = this;
      generic.jsonrpc.fetch({
        method: 'user.googleAIRecommend',
        params: [params],
        onSuccess: function (response) {
          var data = JSON.parse(response.getValue());
          if (data && data.results && data.results.length !== 0) {
            self.processResponse(data, $container);
          } else {
            // hide container if no results
            $container.addClass('hidden');
          }
        },
        onFailure: function (response) {
          console.log(response.getMessages());
        }
      });
    },

    processResponse: function (data, $container) {
      var self = this;
      var $template = $container.find('.js-product-recommendations-v2__grid');
      var gridNode = $template.length
        ? $template[0].content.querySelector(`[data-component='product-grid']`)
        : null;

      if (!gridNode) {
        return;
      }

      var recommendationToken = data.recommendationToken;
      var items = data.results.map((id) => ({
        type: 'product',
        params: {
          id: id.id
        }
      }));
      var config = JSON.parse(gridNode.getAttribute('data-config'));
      config.items = items;
      config.gridSource = "google_recs";
      gridNode.setAttribute('data-config', JSON.stringify(config));

      self.appendTokenToProductUrls($container, recommendationToken);

      if (site.trackingDataLayer) {
        site.trackingDataLayer.update({
          ai_recommendation_token: recommendationToken
        });
      }

      // Putting the configured node in the document is what mounts the grid.
      // Insert the whole fragment, not just the grid: the mount-point helper
      // also emits a sibling .sd-mount-skeleton, and mount_skeleton.js is what
      // adds sd-mounted once the grid has content.
      $template.replaceWith($template[0].content);
    },

    appendTokenToProductUrls: function ($gridContainer, recommendationToken) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            var $productBriefs = $gridContainer.find('.js-product-brief-wrapper');
            if ($productBriefs.length !== 0) {
              $productBriefs.each(function () {
                var $productBrief = $(this);
                var $imageLink = $productBrief.find('.js-styled-product-image-container');
                var $displayNameLink = $productBrief.find('.js-product-display-name');
                var $descriptionLink = $productBrief.find('.js-product-description-wrapper');
                appendToken($imageLink);
                appendToken($displayNameLink);
                appendToken($descriptionLink);
              });
            }
          }
        });
      });
      var observerConfig = { attributes: false, childList: true, subtree: true };
      var appendToken = function ($link) {
        var href = $link.attr('href');
        if (typeof href !== 'undefined' && href !== '' && href.indexOf('rtoken') === -1) {
          var newHref = href + '/?rtoken=' + recommendationToken;
          $link.attr('href', newHref);
        }
      };
      observer.observe($gridContainer[0], observerConfig);
    },

    attached: false
  };
})(jQuery);
